export const createReqBody = (filter, networkId) => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      networkId: networkId,
      action: filter.action[0] ? filter.action : '*',
      status: filter.status[0] ? filter.status : '*',
      'sources.endpointType': filter['sources.endpointType'][0]
        ? filter['sources.endpointType']
        : '*',
      'destinations.endpointType': filter['destinations.endpointType'][0]
        ? filter['destinations.endpointType']
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
